<div class="c__slider" [ngClass]="{'no-style': noStyle}">
  @if (configDefault(); as config) {
    <swiper
      #swiperContainer
      class="swiper-container swiper-container-{{uuidSlider}}"
      [config]="config"
      (init)="onSliderInit()"
      (imagesReady)="onImageReady()"
      (resize)="onResize()"
      [navigation]="navigation()"
      (slideChangeTransitionEnd)="updateSlidesStatus()"
      (slideNextTransitionStart)="onSlideNext()"
      (slidePrevTransitionStart)="onSlidePrev()"
    >
      @for (item of items; track $index) {
        <ng-template swiperSlide class="c__item">
          <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item, index: $index }" />
        </ng-template>
      }
    </swiper>
  }
  <div class="c__controls-container c__wrapper-control" [hidden]="!(items?.length > 1)">
    <div class="c__controls">
      <button sd-button
        #buttonPrev
        type="button"
        [brand]="brand"
        [isIcon]="true"
        icon="icon-arrow-left"
        class="c__swiper-button-prev c__swiper-button-prev-{{uuidSlider}} is-theme-invert"
        [attr.aria-disabled]="isPrevBtnDisabled()"
      >
        <span class="is-visually-hidden">
          {{ 'sliders.actions.prev' | translate: { 'context': context } }}
        </span>
      </button>
      <button sd-button
        #buttonNext
        type="button"
        [isIcon]="true"
        [brand]="brand"
        icon="icon-arrow-right"
        class="c__swiper-button-next c__swiper-button-next-{{uuidSlider}} is-theme-invert"
        [attr.aria-disabled]="isNextBtnDisabled()"
      >
        <span class="is-visually-hidden">
          {{ 'sliders.actions.next' | translate: { 'context': context } }}
        </span>
      </button>
    </div>
  </div>
</div>
